import { Actions, ActionTypes } from '@appStore/app/actions';

export interface State {
    activeSidebars: string[],
}

export const initialState: State = {
    activeSidebars: []
}

export function reducer(state = initialState, action: Actions): State {
    switch(action.type){
        case ActionTypes.ActivateSidebar:
            // Check if the sidebar is already active, if so, return the current state
            if (state.activeSidebars.includes(action.payload)) {
                return state;
            }
            return {...state, activeSidebars: [...state.activeSidebars, action.payload] };
        case ActionTypes.InactivateSidebar:
            return {...state, activeSidebars: state.activeSidebars.filter(sidebar => sidebar !== action.payload) };
        default:
            return state;
    }
}

export const _getAnyActiveSidbars = (state: State) => state.activeSidebars.length > 0;
